
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexAzAXvknF5iLJKRdSt1I45G_14i6SMA1mDLyMy64q_45yQMeta } from "/usr/local/lsws/tickea.com/html/pages/[type]-tickets/[[dateId]]/index.vue?macro=true";
import { default as seatsuwh88ZREp8yx8MCL8C28pIA9Kp_45hOQBOpYe7L1jMPcQMeta } from "/usr/local/lsws/tickea.com/html/pages/[type]-tickets/[[dateId]]/seats.vue?macro=true";
import { default as ticketswNBeHz00_45_45AUZkmdhUe3Unj4_yijIKHFaWCCX87prUYMeta } from "/usr/local/lsws/tickea.com/html/pages/[type]-tickets/[[dateId]]/tickets.vue?macro=true";
import { default as _64_91username_93VusT9kaRySbSm0e9uvRlFdCNehEmg_O_456rHZ_TBgToIMeta } from "/usr/local/lsws/tickea.com/html/pages/@[username].vue?macro=true";
import { default as about4fUyIKNirDB_pItHGB0eanGJWxZw3aegiHyDdghLiHMMeta } from "/usr/local/lsws/tickea.com/html/pages/about.vue?macro=true";
import { default as _91username_93B5Cc_4524OoHddTg_ucq45RKXj6e2euD1XyXZPfv0taqcMeta } from "/usr/local/lsws/tickea.com/html/pages/artist/[username].vue?macro=true";
import { default as cancel_45policy4013_5sPQFvoftLwuqdSFR7IM0VuNNKr65_G2M08NFgMeta } from "/usr/local/lsws/tickea.com/html/pages/cancel-policy.vue?macro=true";
import { default as cookie_45policyfQmJqjE3g6Y8_YEVK95_45f_45pIIcUgE0ESA3RbEGPTFtAMeta } from "/usr/local/lsws/tickea.com/html/pages/cookie-policy.vue?macro=true";
import { default as delete_45account3UxugvFeLV_f4vjhx8BdPEzfmROksKsLYbjwpfUWehUMeta } from "/usr/local/lsws/tickea.com/html/pages/delete-account.vue?macro=true";
import { default as downloadLWYZ05YXNoyibZnTRnqzZj8DtpSKNSs3a5WT94F8uJ4Meta } from "/usr/local/lsws/tickea.com/html/pages/download.vue?macro=true";
import { default as _91hash_93UWmDJpk9nvA_a3cgu9FotdCv3FtrmMWbBYQ9VVcQZcoMeta } from "/usr/local/lsws/tickea.com/html/pages/get-tickets/[hash].vue?macro=true";
import { default as helpH9SCCWGk9NDtMctsmCKidOyzJeNp6z5b4NXU1qYEHAcMeta } from "/usr/local/lsws/tickea.com/html/pages/help.vue?macro=true";
import { default as indexoCv06CLBCzEPlgTT1zfmaTneU6mAtT_QKeva5aRw5gQMeta } from "/usr/local/lsws/tickea.com/html/pages/index.vue?macro=true";
import { default as callback_45Nvlk8Jt4M3PyM9tXHG8hQ7pR8XS35CdY7dSK_459ShLMMeta } from "/usr/local/lsws/tickea.com/html/pages/payment-method/[method]/callback.vue?macro=true";
import { default as platform_45MDuRTeX_45Qog0ME_45O86VqzARO8O7VdLNfwchQzPZHkwMeta } from "/usr/local/lsws/tickea.com/html/pages/platform.vue?macro=true";
import { default as privacy_45policyK5NMcuBkfujETN7ikGPnK6O5pMywCHX_Hk5942omVSAMeta } from "/usr/local/lsws/tickea.com/html/pages/privacy-policy.vue?macro=true";
import { default as _91username_93moLq2i52PkZS984WPYLVoFpwYo4tiFV_45bsBCyrCMzlQMeta } from "/usr/local/lsws/tickea.com/html/pages/producer/[username].vue?macro=true";
import { default as sell8lO7iLocc_Qkv7w8pTcdzmTKs1bW8aLywstOAXWvP_oMeta } from "/usr/local/lsws/tickea.com/html/pages/sell.vue?macro=true";
import { default as terms_45and_45conditionsMxYiMszEG_45tHlwZcoL2_45K2vmJ5od1SGqcAEcOO73k7YMeta } from "/usr/local/lsws/tickea.com/html/pages/terms-and-conditions.vue?macro=true";
import { default as use_45conditionsCaiQPppFKIifgVz_DtegFseA7TxedTcuJ0C3Pq_vaY0Meta } from "/usr/local/lsws/tickea.com/html/pages/use-conditions.vue?macro=true";
export default [
  {
    name: "type-tickets-dateId___pa___default",
    path: "/:type()-tickets/:dateId?",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/[type]-tickets/[[dateId]]/index.vue")
  },
  {
    name: "type-tickets-dateId___pa",
    path: "/pa/:type()-tickets/:dateId?",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/[type]-tickets/[[dateId]]/index.vue")
  },
  {
    name: "type-tickets-dateId___ve",
    path: "/ve/:type()-tickets/:dateId?",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/[type]-tickets/[[dateId]]/index.vue")
  },
  {
    name: "type-tickets-dateId-seats___pa___default",
    path: "/:type()-tickets/:dateId?/seats",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/[type]-tickets/[[dateId]]/seats.vue")
  },
  {
    name: "type-tickets-dateId-seats___pa",
    path: "/pa/:type()-tickets/:dateId?/seats",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/[type]-tickets/[[dateId]]/seats.vue")
  },
  {
    name: "type-tickets-dateId-seats___ve",
    path: "/ve/:type()-tickets/:dateId?/seats",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/[type]-tickets/[[dateId]]/seats.vue")
  },
  {
    name: "type-tickets-dateId-tickets___pa___default",
    path: "/:type()-tickets/:dateId?/tickets",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/[type]-tickets/[[dateId]]/tickets.vue")
  },
  {
    name: "type-tickets-dateId-tickets___pa",
    path: "/pa/:type()-tickets/:dateId?/tickets",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/[type]-tickets/[[dateId]]/tickets.vue")
  },
  {
    name: "type-tickets-dateId-tickets___ve",
    path: "/ve/:type()-tickets/:dateId?/tickets",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/[type]-tickets/[[dateId]]/tickets.vue")
  },
  {
    name: "@username___pa___default",
    path: "/@:username()",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/@[username].vue")
  },
  {
    name: "@username___pa",
    path: "/pa/@:username()",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/@[username].vue")
  },
  {
    name: "@username___ve",
    path: "/ve/@:username()",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/@[username].vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/about.vue")
  },
  {
    name: "artist-username___pa___default",
    path: "/artist/:username()",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/artist/[username].vue")
  },
  {
    name: "artist-username___pa",
    path: "/pa/artist/:username()",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/artist/[username].vue")
  },
  {
    name: "artist-username___ve",
    path: "/ve/artist/:username()",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/artist/[username].vue")
  },
  {
    name: "cancel-policy",
    path: "/cancel-policy",
    meta: cancel_45policy4013_5sPQFvoftLwuqdSFR7IM0VuNNKr65_G2M08NFgMeta || {},
    component: () => import("/usr/local/lsws/tickea.com/html/pages/cancel-policy.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    meta: cookie_45policyfQmJqjE3g6Y8_YEVK95_45f_45pIIcUgE0ESA3RbEGPTFtAMeta || {},
    component: () => import("/usr/local/lsws/tickea.com/html/pages/cookie-policy.vue")
  },
  {
    name: "delete-account___pa___default",
    path: "/delete-account",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/delete-account.vue")
  },
  {
    name: "delete-account___pa",
    path: "/pa/delete-account",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/delete-account.vue")
  },
  {
    name: "delete-account___ve",
    path: "/ve/delete-account",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/delete-account.vue")
  },
  {
    name: "download",
    path: "/download",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/download.vue")
  },
  {
    name: "get-tickets-hash___pa___default",
    path: "/get-tickets/:hash()",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/get-tickets/[hash].vue")
  },
  {
    name: "get-tickets-hash___pa",
    path: "/pa/get-tickets/:hash()",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/get-tickets/[hash].vue")
  },
  {
    name: "get-tickets-hash___ve",
    path: "/ve/get-tickets/:hash()",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/get-tickets/[hash].vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/help.vue")
  },
  {
    name: "index___pa___default",
    path: "/",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/index.vue")
  },
  {
    name: "index___pa",
    path: "/pa",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/index.vue")
  },
  {
    name: "index___ve",
    path: "/ve",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/index.vue")
  },
  {
    name: "payment-method-method-callback___pa___default",
    path: "/payment-method/:method()/callback",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/payment-method/[method]/callback.vue")
  },
  {
    name: "payment-method-method-callback___pa",
    path: "/pa/payment-method/:method()/callback",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/payment-method/[method]/callback.vue")
  },
  {
    name: "payment-method-method-callback___ve",
    path: "/ve/payment-method/:method()/callback",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/payment-method/[method]/callback.vue")
  },
  {
    name: "platform",
    path: "/platform",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/platform.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyK5NMcuBkfujETN7ikGPnK6O5pMywCHX_Hk5942omVSAMeta || {},
    component: () => import("/usr/local/lsws/tickea.com/html/pages/privacy-policy.vue")
  },
  {
    name: "producer-username___pa___default",
    path: "/producer/:username()",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/producer/[username].vue")
  },
  {
    name: "producer-username___pa",
    path: "/pa/producer/:username()",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/producer/[username].vue")
  },
  {
    name: "producer-username___ve",
    path: "/ve/producer/:username()",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/producer/[username].vue")
  },
  {
    name: "sell",
    path: "/sell",
    component: () => import("/usr/local/lsws/tickea.com/html/pages/sell.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    meta: terms_45and_45conditionsMxYiMszEG_45tHlwZcoL2_45K2vmJ5od1SGqcAEcOO73k7YMeta || {},
    component: () => import("/usr/local/lsws/tickea.com/html/pages/terms-and-conditions.vue")
  },
  {
    name: "use-conditions",
    path: "/use-conditions",
    meta: use_45conditionsCaiQPppFKIifgVz_DtegFseA7TxedTcuJ0C3Pq_vaY0Meta || {},
    component: () => import("/usr/local/lsws/tickea.com/html/pages/use-conditions.vue")
  }
]